import React, { Component } from 'react';
import {
  Divider,
  Switch,
  Button,
  Slider,
  NumericInput,
  FormGroup,
} from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class AutoEvents extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      LPNEvent: false,
      FFAEvent: false,
      FFAEventMinLevel: 80,
      FFAEventWorldID: '',
      BattleRoyaleEvent: true,
      SurvivalEvent: false,
      SurvivalEventShowNames: false,
      SurvivalEventMaxKillHWID: '',
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Auto Events
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td>Battle Royale Event</td>
              <td>
                <Switch
                  checked={this.state.BattleRoyaleEvent}
                  {...SwitchOnOff}
                  onChange={this.handleChange('BattleRoyaleEvent')}
                />
              </td>
            </tr>

            <tr>
              <td style={{ minWidth: '150px' }}>Lucky Party Number Event</td>
              <td>
                <Switch
                  checked={this.state.LPNEvent}
                  {...SwitchOnOff}
                  onChange={this.handleChange('LPNEvent')}
                />
              </td>
            </tr>

            <tr>
              <td>Free For All Event</td>
              <td>
                <Switch
                  checked={this.state.FFAEvent}
                  {...SwitchOnOff}
                  onChange={this.handleChange('FFAEvent')}
                />
              </td>
            </tr>

            <tr>
              <td>Free For All Min Level</td>
              <td style={{ width: '360px' }}>
                <Slider
                  disabled={!this.state.FFAEvent}
                  min={0}
                  max={120}
                  labelStepSize={10}
                  onChange={this.handleChange('FFAEventMinLevel')}
                  value={this.state.FFAEventMinLevel}
                />
              </td>
            </tr>

            <tr>
              <td>Free For All WorldID</td>
              <td style={{ width: '240px' }}>
                <input
                  disabled={!this.state.FFAEvent}
                  type="number"
                  className="bp3-input d-block w-75"
                  placeholder="Type an ID..."
                  value={this.state.FFAEventWorldID}
                  onChange={this.handleChange('FFAEventWorldID')}
                />
              </td>
            </tr>

            <tr>
              <td>Survival Arena Event</td>
              <td>
                <Switch
                  checked={this.state.SurvivalEvent}
                  {...SwitchOnOff}
                  onChange={this.handleChange('SurvivalEvent')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Survival Arena" className="mb-0">
                  Show Player Names
                </FormGroup>
              </td>
              <td>
                <Switch
                  disabled={!this.state.SurvivalEvent}
                  checked={this.state.SurvivalEventShowNames}
                  {...SwitchOnOff}
                  onChange={this.handleChange('SurvivalEventShowNames')}
                />
              </td>
            </tr>

            <tr>
              <td>
                <FormGroup helperText="in Survival Arena" className="mb-0">
                  Max Kill/HWID
                </FormGroup>
              </td>
              <td style={{ width: '240px' }}>
                <FormGroup
                  helperText="Kill limit / per player pc hwid"
                  className="mb-4"
                >
                  <NumericInput
                    disabled={!this.state.SurvivalEvent}
                    style={{ width: '190px' }}
                    value={this.state.SurvivalEventMaxKillHWID}
                    placeholder="Type max kill/HWID count..."
                    onValueChange={this.handleChange(
                      'SurvivalEventMaxKillHWID'
                    )}
                    min={0}
                  />
                </FormGroup>
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
